import React from "react";

export default function Footer() {
  return (
    <footer>
      <p>Made with ❤️ by <a href="https://github.com/lostvikx" target="_blank" rel="noreferrer">Vikram S. Negi</a></p>
    </footer>
  );
}